module.exports = __webpack_public_path__ + "img/bronze-5.338474ba.png";